(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5021],{

/***/ 63395:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[company]/settings/users",
      function () {
        return __webpack_require__(27134);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 6480:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ Sidebar; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67294);
/* harmony import */ var shared_ui__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(83083);
/* harmony import */ var _sidebar_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(10078);
/* harmony import */ var _sidebar_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_sidebar_module_scss__WEBPACK_IMPORTED_MODULE_5__);







const Sidebar = (props)=>{
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    const [activeMenu, setActiveMenu] = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)();
    const { groups , menu  } = (0,react__WEBPACK_IMPORTED_MODULE_4__.useMemo)(()=>{
        const propsMenu = props.menu.filter((it)=>it);
        if (!propsMenu.length) return {
            groups: null,
            menu: []
        };
        if ("menu" in propsMenu[0]) {
            const groups = propsMenu.map((it)=>({
                    ...it,
                    menu: it.menu.filter((it)=>it)
                }));
            const menu = groups.map((it)=>it.menu).flat();
            return {
                groups,
                menu
            };
        } else {
            return {
                groups: null,
                menu: propsMenu
            };
        }
    }, [
        props.menu
    ]);
    const checkActiveForDescktop = (menuItem)=>{
        if (router.asPath.startsWith(menuItem.additionalHref)) return true;
        switch(router.asPath){
            case menuItem.href:
                return true;
            case menuItem.additionalHref:
                return true;
            default:
                if (!menuItem.exact) return router.asPath.startsWith(menuItem.href);
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(()=>{
        const activeLink = menu.find((elem)=>{
            if (elem.exact) return router.asPath === elem.additionalHref;
            return router.asPath.startsWith(elem.href);
        });
        setActiveMenu(activeLink);
    }, [
        menu,
        router
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_sidebar_module_scss__WEBPACK_IMPORTED_MODULE_5___default().sidebar), props.sticky && (_sidebar_module_scss__WEBPACK_IMPORTED_MODULE_5___default().sticky), props.className),
        style: props.style,
        id: props.htmlId,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_sidebar_module_scss__WEBPACK_IMPORTED_MODULE_5___default().sidebar_adaptive),
                children: activeMenu ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                    href: props.mainHref,
                    className: (_sidebar_module_scss__WEBPACK_IMPORTED_MODULE_5___default().title),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_ui__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {}),
                        activeMenu.label,
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_sidebar_module_scss__WEBPACK_IMPORTED_MODULE_5___default().spacer)
                        })
                    ]
                }) : menu.map((it)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                        className: (_sidebar_module_scss__WEBPACK_IMPORTED_MODULE_5___default().adaptive_item),
                        href: it.exact ? it.additionalHref : it.href,
                        children: it.label
                    }, it.href))
            }),
            groups === null || groups === void 0 ? void 0 : groups.map((it, key)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react__WEBPACK_IMPORTED_MODULE_4__.Fragment, {
                    children: [
                        it.title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_sidebar_module_scss__WEBPACK_IMPORTED_MODULE_5___default().group_title),
                            children: it.title
                        }),
                        it.menu.map((it)=>{
                            const active = checkActiveForDescktop(it);
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                                href: it.href,
                                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_sidebar_module_scss__WEBPACK_IMPORTED_MODULE_5___default().item), active && (_sidebar_module_scss__WEBPACK_IMPORTED_MODULE_5___default().active)),
                                children: it.label
                            }, it.href);
                        })
                    ]
                }, key)),
            !groups && menu.map((it)=>{
                const active = checkActiveForDescktop(it);
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                    href: it.href,
                    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_sidebar_module_scss__WEBPACK_IMPORTED_MODULE_5___default().item), active && (_sidebar_module_scss__WEBPACK_IMPORTED_MODULE_5___default().active)),
                    children: it.label
                }, it.href);
            })
        ]
    });
};
Sidebar.defaultProps = {
    sticky: true
};


/***/ }),

/***/ 47656:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ WithSidebarContainer; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var modules_layout_ui_container__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(57711);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var _with_sidebar_container_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11682);
/* harmony import */ var _with_sidebar_container_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_with_sidebar_container_module_scss__WEBPACK_IMPORTED_MODULE_5__);






const WithSidebarContainer = (props)=>{
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    const hideOnMobile = router.asPath === props.mainHref;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(modules_layout_ui_container__WEBPACK_IMPORTED_MODULE_4__/* .Container */ .W, {
        fullWidth: props.fullWidth,
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_with_sidebar_container_module_scss__WEBPACK_IMPORTED_MODULE_5___default().with_sidebar_container), props.className),
        style: props.style,
        htmlId: props.htmlId,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_with_sidebar_container_module_scss__WEBPACK_IMPORTED_MODULE_5___default().sidebar),
                children: props.sidebar
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("main", {
                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_with_sidebar_container_module_scss__WEBPACK_IMPORTED_MODULE_5___default().main), hideOnMobile && (_with_sidebar_container_module_scss__WEBPACK_IMPORTED_MODULE_5___default().hide_on_mobile)),
                children: props.children
            })
        ]
    });
};
WithSidebarContainer.defaultProps = {};


/***/ }),

/***/ 80665:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ useMyPermissions; }
/* harmony export */ });
/* unused harmony export convertPermissions */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var shared_api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22823);
/* harmony import */ var shared_api__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94840);
/* harmony import */ var shared_api__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(32636);


const convertPermissions = (roleType, permissions)=>{
    const set = new Set(permissions);
    const isOwner = roleType === shared_api__WEBPACK_IMPORTED_MODULE_1__/* .CompanyEmployeeRoleType.OWNER */ .Or.OWNER;
    return {
        finances: {
            budgets: {
                read: set.has(shared_api__WEBPACK_IMPORTED_MODULE_2__/* .CompanyRolePermission.FINANCIAL_PLAN_READ */ .Mn.FINANCIAL_PLAN_READ),
                write: set.has(shared_api__WEBPACK_IMPORTED_MODULE_2__/* .CompanyRolePermission.FINANCIAL_PLAN_CONDUCT */ .Mn.FINANCIAL_PLAN_CONDUCT),
                approve: set.has(shared_api__WEBPACK_IMPORTED_MODULE_2__/* .CompanyRolePermission.FINANCIAL_PLAN_APPROVE */ .Mn.FINANCIAL_PLAN_APPROVE)
            },
            plannings: {
                read: set.has(shared_api__WEBPACK_IMPORTED_MODULE_2__/* .CompanyRolePermission.FINANCIAL_PLAN_READ */ .Mn.FINANCIAL_PLAN_READ),
                write: set.has(shared_api__WEBPACK_IMPORTED_MODULE_2__/* .CompanyRolePermission.FINANCIAL_PLAN_CONDUCT */ .Mn.FINANCIAL_PLAN_CONDUCT),
                approve: set.has(shared_api__WEBPACK_IMPORTED_MODULE_2__/* .CompanyRolePermission.FINANCIAL_PLAN_APPROVE */ .Mn.FINANCIAL_PLAN_APPROVE)
            },
            fundingRequests: {
                create: true,
                readAll: set.has(shared_api__WEBPACK_IMPORTED_MODULE_2__/* .CompanyRolePermission.CLAIM_READ_ALL */ .Mn.CLAIM_READ_ALL),
                acceptOrDecline: set.has(shared_api__WEBPACK_IMPORTED_MODULE_2__/* .CompanyRolePermission.CLAIM_ALLOW_FOR_FINANCIAL_PLANNING */ .Mn.CLAIM_ALLOW_FOR_FINANCIAL_PLANNING),
                approve: set.has(shared_api__WEBPACK_IMPORTED_MODULE_2__/* .CompanyRolePermission.CLAIM_APPROVE */ .Mn.CLAIM_APPROVE),
                close: set.has(shared_api__WEBPACK_IMPORTED_MODULE_2__/* .CompanyRolePermission.CLAIM_APPROVE */ .Mn.CLAIM_APPROVE) || set.has(shared_api__WEBPACK_IMPORTED_MODULE_2__/* .CompanyRolePermission.CLAIM_PAY_OFF */ .Mn.CLAIM_PAY_OFF),
                pay: set.has(shared_api__WEBPACK_IMPORTED_MODULE_2__/* .CompanyRolePermission.CLAIM_PAY_OFF */ .Mn.CLAIM_PAY_OFF)
            },
            funds: {
                withdraw: set.has(shared_api__WEBPACK_IMPORTED_MODULE_2__/* .CompanyRolePermission.FUND_WITHDRAW */ .Mn.FUND_WITHDRAW),
                deposit: set.has(shared_api__WEBPACK_IMPORTED_MODULE_2__/* .CompanyRolePermission.FUND_DEPOSIT */ .Mn.FUND_DEPOSIT),
                readProtected: set.has(shared_api__WEBPACK_IMPORTED_MODULE_2__/* .CompanyRolePermission.FUND_SECURED_READ */ .Mn.FUND_SECURED_READ)
            }
        },
        company: {
            general: {
                update: isOwner,
                delete: isOwner
            },
            members: {
                invite: isOwner,
                update: isOwner,
                remove: isOwner
            },
            roles: {
                write: isOwner
            }
        }
    };
};
const useMyPermissions = (companySlug)=>{
    var _me_data;
    const me = shared_api__WEBPACK_IMPORTED_MODULE_3__/* .api.companyEmployee.useCompanyEmployeeMe */ .h.companyEmployee.useCompanyEmployeeMe(companySlug);
    const role = (_me_data = me.data) === null || _me_data === void 0 ? void 0 : _me_data.companyEmployeeRole;
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>!role ? null : convertPermissions(role.type, role.permissions), [
        role
    ]);
};


/***/ }),

/***/ 59906:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "q": function() { return /* binding */ CompanyLayout; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/modules/auth/model/auth-guard.model.tsx
var auth_guard_model = __webpack_require__(95244);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/modules/company/entities/company/company-expired/company-expired.module.scss
var company_expired_module = __webpack_require__(60978);
var company_expired_module_default = /*#__PURE__*/__webpack_require__.n(company_expired_module);
;// CONCATENATED MODULE: ./src/modules/company/entities/company/company-expired/company-expired.tsx




const CompanyExpired = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classnames_default()((company_expired_module_default()).company_expired, props.className),
        style: props.style,
        id: props.htmlId,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (company_expired_module_default()).inner,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                children: "Для этой компании закончился период доступа"
            })
        })
    });
};
CompanyExpired.defaultProps = {};

// EXTERNAL MODULE: ./src/modules/layout/ui/header-dashboard/header-dashboard.tsx + 13 modules
var header_dashboard = __webpack_require__(35622);
// EXTERNAL MODULE: ./src/modules/layout/ui/header-navigation/header-navigation.tsx
var header_navigation = __webpack_require__(20168);
// EXTERNAL MODULE: ./src/modules/layout/ui/header-title/header-title.tsx
var header_title = __webpack_require__(35629);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/pages/_router.tsx
var _router = __webpack_require__(8254);
// EXTERNAL MODULE: ./src/shared/api/init.tsx + 231 modules
var init = __webpack_require__(32636);
;// CONCATENATED MODULE: ./src/pages/[company]/_layout.tsx








const CompanyLayout = (props)=>{
    const { query  } = (0,router.useRouter)();
    const companySlug = query.company;
    const company = init/* api.company.useCompanyGet */.h.company.useCompanyGet(companySlug);
    (0,auth_guard_model/* useGuardAuthedOnly */.T)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: props.className,
        style: props.style,
        id: props.htmlId,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(header_dashboard/* HeaderDashboard */.w, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(header_navigation/* HeaderNavigation */.F, {
                menu: [
                    {
                        label: "Финансы",
                        href: _router/* default.company */.Z.company(companySlug).finances.href
                    },
                    // { label: "Департаменты", href: pages.company(companySlug).departments.href },
                    {
                        label: "Настройки",
                        href: _router/* default.company */.Z.company(companySlug).settings.href
                    }
                ],
                sticky: props.stickyNavigation
            }),
            company.data && !company.data.hasAccess ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyExpired, {}) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    props.title && /*#__PURE__*/ (0,jsx_runtime.jsx)(header_title/* HeaderTitle */.G, {
                        fullWidth: true,
                        back: props.back,
                        actions: props.actions,
                        children: props.title
                    }),
                    props.children
                ]
            })
        ]
    });
};
CompanyLayout.defaultProps = {
    stickyNavigation: true
};


/***/ }),

/***/ 10830:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ CompanySettingsLayout; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var modules_layout__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47656);
/* harmony import */ var modules_layout__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(6480);
/* harmony import */ var pages_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8254);
/* harmony import */ var _layout__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(59906);






const CompanySettingsLayout = (props)=>{
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    const slug = router.query.company;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_layout__WEBPACK_IMPORTED_MODULE_3__/* .CompanyLayout */ .q, {
        title: "Настройки",
        className: props.className,
        style: props.style,
        htmlId: props.htmlId,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(modules_layout__WEBPACK_IMPORTED_MODULE_4__/* .WithSidebarContainer */ .I, {
            mainHref: pages_router__WEBPACK_IMPORTED_MODULE_5__/* ["default"].company */ .Z.company(slug).settings.href,
            sidebar: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(modules_layout__WEBPACK_IMPORTED_MODULE_6__/* .Sidebar */ .Y, {
                mainHref: pages_router__WEBPACK_IMPORTED_MODULE_5__/* ["default"].company */ .Z.company(slug).settings.href,
                menu: [
                    {
                        label: "Общие",
                        href: pages_router__WEBPACK_IMPORTED_MODULE_5__/* ["default"].company */ .Z.company(slug).settings.href,
                        exact: true,
                        additionalHref: pages_router__WEBPACK_IMPORTED_MODULE_5__/* ["default"].company */ .Z.company(slug).settings.general.href
                    },
                    {
                        label: "Сотрудники",
                        href: pages_router__WEBPACK_IMPORTED_MODULE_5__/* ["default"].company */ .Z.company(slug).settings.users.href
                    },
                    {
                        label: "Роли",
                        href: pages_router__WEBPACK_IMPORTED_MODULE_5__/* ["default"].company */ .Z.company(slug).settings.roles.href
                    }
                ]
            }),
            children: props.children
        })
    });
};


/***/ }),

/***/ 27134:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ users_page; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/shared/api/init.tsx + 231 modules
var init = __webpack_require__(32636);
// EXTERNAL MODULE: ./src/shared/lib/use-api-method.ts
var use_api_method = __webpack_require__(24453);
// EXTERNAL MODULE: ./src/shared/ui/modal/modal.tsx + 7 modules
var modal = __webpack_require__(4629);
// EXTERNAL MODULE: ./src/shared/ui/snippet/snippet.module.scss
var snippet_module = __webpack_require__(13412);
var snippet_module_default = /*#__PURE__*/__webpack_require__.n(snippet_module);
;// CONCATENATED MODULE: ./src/shared/ui/icon/copy.svg
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgCopy = function SvgCopy(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
    d: "M11.334 4.667V3a1.667 1.667 0 0 0-1.667-1.667H3A1.667 1.667 0 0 0 1.333 3v6.667A1.667 1.667 0 0 0 3 11.333h1.667m1.667-6.666H13c.92 0 1.667.746 1.667 1.666V13c0 .92-.746 1.667-1.667 1.667H6.333c-.92 0-1.666-.747-1.666-1.667V6.333c0-.92.746-1.666 1.667-1.666Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
/* harmony default export */ var copy = (SvgCopy);
;// CONCATENATED MODULE: ./src/shared/lib/copy-text.ts
const copyText = async (text)=>{
    try {
        await navigator.clipboard.writeText(text);
    } catch (err) {
        console.error("Failed to copy: ", err);
    }
};

// EXTERNAL MODULE: ./node_modules/react-hot-toast/dist/index.mjs + 1 modules
var dist = __webpack_require__(86501);
;// CONCATENATED MODULE: ./src/shared/ui/snippet/snippet.tsx







const Snippet = (props)=>{
    const onCopy = (value)=>{
        copyText(value).then((reps)=>{
            dist/* default.success */.ZP.success("Ссылка скопирована", {
                duration: 1000
            });
        }).catch((e)=>{
            dist/* default.error */.ZP.error(e, {
                duration: 1000
            });
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()((snippet_module_default()).snippet, props.type === "lite" && props.fill ? (snippet_module_default()).lite_fill : props.type === "lite" && (snippet_module_default()).lite, props.type === "secondary" && props.fill ? (snippet_module_default()).secondary_fill : props.type === "secondary" && (snippet_module_default()).secondary, props.type === "success" && props.fill ? (snippet_module_default()).success_fill : props.type === "success" && (snippet_module_default()).success, props.type === "error" && props.fill ? (snippet_module_default()).error_fill : props.type === "error" && (snippet_module_default()).error, props.type === "warning" && props.fill ? (snippet_module_default()).warning_fill : props.type === "warning" && (snippet_module_default()).warning, props.fill && (snippet_module_default()).fill, props.className),
        style: {
            ...props.style,
            width: props.width
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: (snippet_module_default()).text,
                children: props.text
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                className: (snippet_module_default()).button,
                onClick: ()=>onCopy(props.text),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(copy, {})
            })
        ]
    });
};
Snippet.defaultProps = {};

// EXTERNAL MODULE: ./src/shared/ui/button/button.tsx
var button_button = __webpack_require__(76780);
;// CONCATENATED MODULE: ./src/modules/company/entities/employee-invite-link/employee-invite-link-modal.tsx





const EmployeeInviteLinkModal = (props)=>{
    var _invite_data;
    const invite = init/* api.companyInvite.useCompanyInviteInvite */.h.companyInvite.useCompanyInviteInvite(props.companySlug);
    const submit = (0,use_api_method/* useApiMethod */.W)(init/* api.companyInvite.companyInviteReset */.h.companyInvite.companyInviteReset);
    const onReset = async ()=>{
        await submit.call(props.companySlug);
        await invite.mutate();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(modal/* Modal */.u, {
        onClose: props.close,
        width: 480,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(modal/* Modal.Header */.u.Header, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(modal/* Modal.Title */.u.Title, {
                        children: "Ссылка для приглашения"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(modal/* Modal.Subtitle */.u.Subtitle, {
                        style: {
                            color: "var(--geist-secondary)"
                        },
                        children: "Разрешите другим людям присоединиться к вашей команде по ссылке ниже."
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(modal/* Modal.Body */.u.Body, {
                style: {
                    paddingTop: "0px"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Snippet, {
                        fill: true,
                        text: "control.online/invite/".concat((_invite_data = invite.data) === null || _invite_data === void 0 ? void 0 : _invite_data.invite),
                        width: "100%"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(button_button/* Button */.z, {
                        size: "small",
                        type: "secondary",
                        style: {
                            marginTop: "24px"
                        },
                        onClick: onReset,
                        children: "Сбросить ссылку"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(modal/* Modal.Actions */.u.Actions, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(modal/* Modal.Action */.u.Action, {
                    htmlType: "button",
                    onClick: props.close,
                    children: "Ок"
                })
            })
        ]
    });
};
EmployeeInviteLinkModal.defaultProps = {};

// EXTERNAL MODULE: ./src/shared/ui/entity/entity.tsx + 3 modules
var entity = __webpack_require__(51978);
// EXTERNAL MODULE: ./src/shared/ui/error/error.tsx
var error = __webpack_require__(64871);
// EXTERNAL MODULE: ./src/shared/ui/loading-dots/loading-dots.tsx
var loading_dots = __webpack_require__(42966);
;// CONCATENATED MODULE: ./src/modules/company/features/employee-invite-create/employee-invite-create-modal.tsx






const EmployeeInviteCreateModal = (props)=>{
    const submit = (0,use_api_method/* useApiMethod */.W)(init/* api.companyEmployeeInvite.companyEmployeeInviteCreate */.h.companyEmployeeInvite.companyEmployeeInviteCreate);
    const inviteList = init/* api.companyEmployeeInvite.useCompanyEmployeeInviteList */.h.companyEmployeeInvite.useCompanyEmployeeInviteList(props.companySlug);
    const roles = init/* api.companyRbac.useCompanyEmployeeRoleList */.h.companyRbac.useCompanyEmployeeRoleList(props.companySlug);
    const roleNames = (0,react.useMemo)(()=>{
        var _roles_data;
        return new Map((_roles_data = roles.data) === null || _roles_data === void 0 ? void 0 : _roles_data.map((it)=>[
                it.id,
                it.name
            ]));
    }, [
        roles.data
    ]);
    const onSubmit = async (e)=>{
        e.preventDefault();
        await submit.call(props.companySlug, props.data);
        await inviteList.mutate();
        await props.onSuccess();
        dist/* default.success */.ZP.success("Приглашения отправлены.");
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(modal/* Modal */.u, {
        onClose: props.close,
        width: 500,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
            onSubmit: onSubmit,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(modal/* Modal.Header */.u.Header, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(modal/* Modal.Title */.u.Title, {
                        children: "Приглашение сотрудников"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(modal/* Modal.Body */.u.Body, {
                    children: [
                        props.data.invites.map((it, key)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(entity/* Entity */.J, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(entity/* Entity.Field */.J.Field, {
                                        title: it.email,
                                        style: {
                                            flexBasis: "fit-content"
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(entity/* Entity.Field */.J.Field, {
                                        flex: true,
                                        description: roleNames.get(it.companyEmployeeRoleId),
                                        style: {
                                            flexBasis: "fit-content"
                                        },
                                        right: true
                                    })
                                ]
                            }, key)),
                        submit.error && /*#__PURE__*/ (0,jsx_runtime.jsx)(error/* Error */.j, {
                            style: {
                                marginTop: 24
                            },
                            children: submit.error.message
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(modal/* Modal.Actions */.u.Actions, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(modal/* Modal.Action */.u.Action, {
                            htmlType: "button",
                            onClick: props.close,
                            children: "Отмена"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(modal/* Modal.Action */.u.Action, {
                            htmlType: "submit",
                            disabled: submit.loading,
                            children: !submit.loading ? "Пригласить" : /*#__PURE__*/ (0,jsx_runtime.jsx)(loading_dots/* LoadingDots */.x, {
                                size: 4,
                                children: "Приглашаем"
                            })
                        })
                    ]
                })
            ]
        })
    });
};
EmployeeInviteCreateModal.defaultProps = {};

// EXTERNAL MODULE: ./src/modules/my-permissions/use-my-permissions.ts
var use_my_permissions = __webpack_require__(80665);
// EXTERNAL MODULE: ./src/shared/lib/use-modal.tsx
var use_modal = __webpack_require__(74363);
// EXTERNAL MODULE: ./src/shared/ui/entity-form/entity-form.tsx
var entity_form = __webpack_require__(37641);
// EXTERNAL MODULE: ./src/shared/ui/label/label.tsx
var label = __webpack_require__(72064);
// EXTERNAL MODULE: ./src/shared/ui/input/input.tsx
var input = __webpack_require__(99088);
// EXTERNAL MODULE: ./src/shared/ui/select/select.tsx
var select_select = __webpack_require__(14080);
// EXTERNAL MODULE: ./src/modules/company/features/employee-invite-create/employee-invite-create-form.module.scss
var employee_invite_create_form_module = __webpack_require__(87834);
var employee_invite_create_form_module_default = /*#__PURE__*/__webpack_require__.n(employee_invite_create_form_module);
;// CONCATENATED MODULE: ./src/modules/company/features/employee-invite-create/employee-invite-create-form.tsx










const EmployeeInviteCreateForm = (props)=>{
    const roles = init/* api.companyRbac.useCompanyEmployeeRoleList */.h.companyRbac.useCompanyEmployeeRoleList(props.companySlug);
    const permissions = (0,use_my_permissions/* useMyPermissions */.J)(props.companySlug);
    init/* api.companyInvite.useCompanyInviteInvite */.h.companyInvite.useCompanyInviteInvite(props.companySlug);
    const defaultRole = (0,react.useMemo)(()=>{
        var _roles_data;
        return (_roles_data = roles.data) === null || _roles_data === void 0 ? void 0 : _roles_data.find((it)=>it.type === "DEFAULT");
    }, [
        roles.data
    ]);
    const [invites, setInvites] = (0,react.useState)(()=>{
        return [
            {
                email: "",
                companyEmployeeRoleId: (defaultRole === null || defaultRole === void 0 ? void 0 : defaultRole.id) || ""
            }
        ];
    });
    (0,react.useEffect)(()=>{
        if (defaultRole) {
            setInvites((values)=>values.map((it)=>({
                        ...it,
                        companyEmployeeRoleId: it.companyEmployeeRoleId || defaultRole.id
                    })));
        }
    }, [
        defaultRole
    ]);
    const valid = defaultRole && invites.length && invites.find((it)=>it.email.trim());
    const onSubmit = async (e)=>{
        e.preventDefault();
        if (!valid) return;
        use_modal/* Modals.open */.nK.open(EmployeeInviteCreateModal, {
            companySlug: props.companySlug,
            data: {
                invites: invites.filter((it)=>it.email.trim())
            },
            onSuccess: ()=>{
                return setInvites([
                    {
                        email: "",
                        companyEmployeeRoleId: (defaultRole === null || defaultRole === void 0 ? void 0 : defaultRole.id) || ""
                    }
                ]);
            }
        });
    };
    const onOpenInviteModal = ()=>{
        use_modal/* Modals.open */.nK.open(EmployeeInviteLinkModal, {
            companySlug: props.companySlug
        });
    };
    const hasPermission = !!(permissions === null || permissions === void 0 ? void 0 : permissions.company.members.invite);
    const tabIndex = hasPermission ? undefined : -1;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("form", {
        onSubmit: onSubmit,
        className: classnames_default()((employee_invite_create_form_module_default()).employee_invite_create_form, props.className),
        style: props.style,
        id: props.htmlId,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(entity_form/* EntityForm */.D, {
            disabled: !hasPermission,
            title: "Добавить сотрудников",
            footerNote: !hasPermission && "Добавлять сотрудников может только владелец компании",
            extraActions: /*#__PURE__*/ (0,jsx_runtime.jsx)(button_button/* Button */.z, {
                size: "small",
                type: "secondary",
                onClick: onOpenInviteModal,
                htmlType: "button",
                tabIndex: tabIndex,
                children: "Ссылка для приглашения"
            }),
            primaryAction: /*#__PURE__*/ (0,jsx_runtime.jsx)(button_button/* Button */.z, {
                size: "small",
                htmlType: "submit",
                disabled: !valid,
                tabIndex: tabIndex,
                children: "Выслать приглашения"
            }),
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    invites.map((item, index)=>{
                        var _roles_data;
                        /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                            className: (employee_invite_create_form_module_default()).add_employee_form,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(label/* Label */._, {
                                    value: "Email",
                                    className: (employee_invite_create_form_module_default()).email,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(input/* Input */.I, {
                                        placeholder: "example@mail.com",
                                        type: "email",
                                        value: item.email,
                                        onChange: (e)=>setInvites((currentValue)=>{
                                                const newValue = [
                                                    ...currentValue
                                                ];
                                                newValue[index] = {
                                                    ...newValue[index],
                                                    email: e.target.value
                                                };
                                                return newValue;
                                            }),
                                        tabIndex: tabIndex
                                    }, index)
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(label/* Label */._, {
                                    value: "Роль",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(select_select/* Select */.P, {
                                        className: (employee_invite_create_form_module_default()).select,
                                        options: (_roles_data = roles.data) === null || _roles_data === void 0 ? void 0 : _roles_data.filter((it)=>it.type !== "OWNER").map((it)=>({
                                                value: it.id,
                                                label: it.name
                                            })),
                                        value: item.companyEmployeeRoleId,
                                        onChange: (companyEmployeeRoleId)=>setInvites((currentValue)=>{
                                                const newValue = [
                                                    ...currentValue
                                                ];
                                                newValue[index] = {
                                                    ...newValue[index],
                                                    companyEmployeeRoleId
                                                };
                                                return newValue;
                                            }),
                                        tabIndex: tabIndex
                                    })
                                })
                            ]
                        }, index);
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(button_button/* Button */.z, {
                        size: "small",
                        type: "secondary",
                        onClick: ()=>{
                            return setInvites((invites)=>{
                                return [
                                    ...invites,
                                    {
                                        email: "",
                                        companyEmployeeRoleId: (defaultRole === null || defaultRole === void 0 ? void 0 : defaultRole.id) || ""
                                    }
                                ];
                            });
                        },
                        tabIndex: tabIndex,
                        htmlType: "button",
                        children: "Добавить еще"
                    })
                ]
            })
        })
    });
};

// EXTERNAL MODULE: ./src/shared/lib/error-message.ts
var error_message = __webpack_require__(28455);
// EXTERNAL MODULE: ./src/shared/ui/avatar/avatar.tsx
var avatar = __webpack_require__(57233);
;// CONCATENATED MODULE: ./src/modules/company/entities/employee/employee-entity.tsx






const EmployeeEntity = (props)=>{
    const roleOptions = (0,react.useMemo)(()=>{
        var _props_roles;
        return (_props_roles = props.roles) === null || _props_roles === void 0 ? void 0 : _props_roles.map((it)=>({
                value: it.id,
                label: it.name
            }));
    }, [
        props.roles
    ]);
    const isOwner = props.data.user.id === props.companyOwnerId;
    const canChange = !props.readOnly && !isOwner;
    const onRoleChange = async (newRoleId)=>{
        try {
            await init/* api.companyEmployee.companyEmployeeChangeRole */.h.companyEmployee.companyEmployeeChangeRole(props.companySlug, props.data.id, {
                roleId: newRoleId
            });
        } catch (e) {
            const error = await (0,error_message/* getErrorMessage */.e)(e);
            dist/* default.error */.ZP.error(error.message);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(entity/* Entity */.J, {
        className: props.className,
        style: props.style,
        htmlId: props.htmlId,
        menuItems: props.menuItems,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(entity/* Entity.Field */.J.Field, {
                avatar: /*#__PURE__*/ (0,jsx_runtime.jsx)(avatar/* Avatar */.q, {
                    name: props.data.user.name || props.data.user.email,
                    id: props.data.user.id,
                    image: props.data.user.avatarImage
                }),
                title: props.data.user.name || props.data.user.email,
                description: props.data.user.email
            }),
            !canChange && /*#__PURE__*/ (0,jsx_runtime.jsx)(entity/* Entity.Field */.J.Field, {
                description: props.data.companyEmployeeRole.name,
                right: true
            }),
            canChange && /*#__PURE__*/ (0,jsx_runtime.jsx)(entity/* Entity.Field */.J.Field, {
                right: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(select_select/* Select */.P, {
                    options: roleOptions,
                    value: props.data.companyEmployeeRole.id,
                    onChange: onRoleChange
                })
            })
        ]
    });
};
EmployeeEntity.defaultProps = {};

;// CONCATENATED MODULE: ./src/modules/company/features/employee-remove/employee-remove-modal.tsx





const EmployeeRemoveModal = (props)=>{
    const submit = (0,use_api_method/* useApiMethod */.W)(init/* api.companyEmployee.companyEmployeeArchive */.h.companyEmployee.companyEmployeeArchive);
    const onSubmit = async (e)=>{
        e.preventDefault();
        await submit.call(props.companySlug, props.data.id);
        await props.onSuccess();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(modal/* Modal */.u, {
        onClose: props.close,
        width: 450,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
            onSubmit: onSubmit,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(modal/* Modal.Header */.u.Header, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(modal/* Modal.Title */.u.Title, {
                        children: "Удаление сотрудника"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(modal/* Modal.Body */.u.Body, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(entity/* Entity */.J, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(entity/* Entity.Field */.J.Field, {
                                    flex: true,
                                    title: props.data.user.name || props.data.user.email,
                                    description: props.data.user.email,
                                    style: {
                                        flexBasis: "fit-content"
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(entity/* Entity.Field */.J.Field, {
                                    flex: true,
                                    description: props.data.companyEmployeeRole.name,
                                    right: true,
                                    style: {
                                        flexBasis: "fit-content"
                                    }
                                })
                            ]
                        }),
                        submit.error && /*#__PURE__*/ (0,jsx_runtime.jsx)(error/* Error */.j, {
                            style: {
                                marginTop: 24
                            },
                            children: submit.error.message
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(modal/* Modal.Actions */.u.Actions, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(modal/* Modal.Action */.u.Action, {
                            htmlType: "button",
                            onClick: props.close,
                            children: "Отмена"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(modal/* Modal.Action */.u.Action, {
                            htmlType: "submit",
                            disabled: submit.loading,
                            children: !submit.loading ? "Удалить" : /*#__PURE__*/ (0,jsx_runtime.jsx)(loading_dots/* LoadingDots */.x, {
                                size: 4,
                                children: "Удаление"
                            })
                        })
                    ]
                })
            ]
        })
    });
};
EmployeeRemoveModal.defaultProps = {};

// EXTERNAL MODULE: ./src/shared/ui/list/list.tsx
var list = __webpack_require__(30954);
// EXTERNAL MODULE: ./src/shared/ui/menu/ui/item/menu-item.tsx
var menu_item = __webpack_require__(38234);
;// CONCATENATED MODULE: ./src/modules/company/widgets/employee-list/employee-list.tsx








const EmployeeList = (props)=>{
    const roleList = init/* api.companyRbac.useCompanyEmployeeRoleList */.h.companyRbac.useCompanyEmployeeRoleList(props.companySlug);
    const company = init/* api.company.useCompanyGet */.h.company.useCompanyGet(props.companySlug);
    const permissions = (0,use_my_permissions/* useMyPermissions */.J)(props.companySlug);
    const onRemove = (data)=>{
        return use_modal/* Modals.open */.nK.open(EmployeeRemoveModal, {
            data,
            companySlug: props.companySlug,
            onSuccess: ()=>{
                var _props_mutate;
                return (_props_mutate = props.mutate) === null || _props_mutate === void 0 ? void 0 : _props_mutate.call(props);
            }
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(list/* List */.a, {
        ...props,
        renderItem: (it)=>{
            var _company_data;
            /*#__PURE__*/ return (0,jsx_runtime.jsx)(EmployeeEntity, {
                companySlug: props.companySlug,
                data: it,
                roles: roleList.data,
                companyOwnerId: (_company_data = company.data) === null || _company_data === void 0 ? void 0 : _company_data.ownerUserId,
                readOnly: !(permissions === null || permissions === void 0 ? void 0 : permissions.company.members.update),
                menuItems: (permissions === null || permissions === void 0 ? void 0 : permissions.company.members.remove) && it.companyEmployeeRole.type !== "OWNER" && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(menu_item/* MenuItem */.s, {
                        type: "error",
                        onClick: ()=>onRemove(it),
                        children: "Удалить из компании"
                    })
                })
            });
        }
    });
};
EmployeeList.defaultProps = {};

;// CONCATENATED MODULE: ./src/modules/company/entities/employee-invite/employee-invite-entity.tsx



const EmployeeInviteEntity = (props)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(entity/* Entity */.J, {
        className: props.className,
        style: props.style,
        htmlId: props.htmlId,
        menuItems: props.menuItems,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(entity/* Entity.Field */.J.Field, {
                avatar: /*#__PURE__*/ (0,jsx_runtime.jsx)(avatar/* Avatar */.q, {
                    id: props.data.id,
                    name: props.data.email
                }),
                title: "Отправленное приглашение",
                description: props.data.email
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(entity/* Entity.Field */.J.Field, {
                description: props.data.companyEmployeeRole.name,
                right: true
            })
        ]
    });
EmployeeInviteEntity.defaultProps = {};

;// CONCATENATED MODULE: ./src/modules/company/features/employee-invite-delete/employee-invite-delete-modal.tsx





const EmployeeInviteDeleteModal = (props)=>{
    const submit = (0,use_api_method/* useApiMethod */.W)(init/* api.companyEmployeeInvite.companyEmployeeInviteDelete */.h.companyEmployeeInvite.companyEmployeeInviteDelete);
    const onSubmit = async (e)=>{
        e.preventDefault();
        await submit.call(props.companySlug, props.data.id);
        await props.onSuccess();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(modal/* Modal */.u, {
        onClose: props.close,
        width: 450,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
            onSubmit: onSubmit,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(modal/* Modal.Header */.u.Header, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(modal/* Modal.Title */.u.Title, {
                        children: "Удаление приглашения"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(modal/* Modal.Body */.u.Body, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(entity/* Entity */.J, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(entity/* Entity.Field */.J.Field, {
                                    flex: true,
                                    title: props.data.email
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(entity/* Entity.Field */.J.Field, {
                                    flex: true,
                                    description: props.data.companyEmployeeRole.name,
                                    right: true
                                })
                            ]
                        }),
                        submit.error && /*#__PURE__*/ (0,jsx_runtime.jsx)(error/* Error */.j, {
                            style: {
                                marginTop: 24
                            },
                            children: submit.error.message
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(modal/* Modal.Actions */.u.Actions, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(modal/* Modal.Action */.u.Action, {
                            htmlType: "button",
                            onClick: props.close,
                            children: "Отмена"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(modal/* Modal.Action */.u.Action, {
                            htmlType: "submit",
                            disabled: submit.loading,
                            children: !submit.loading ? "Удалить" : /*#__PURE__*/ (0,jsx_runtime.jsx)(loading_dots/* LoadingDots */.x, {
                                size: 4,
                                children: "Удаление"
                            })
                        })
                    ]
                })
            ]
        })
    });
};
EmployeeInviteDeleteModal.defaultProps = {};

// EXTERNAL MODULE: ./src/shared/ui/empty/empty.tsx
var empty = __webpack_require__(68264);
;// CONCATENATED MODULE: ./src/modules/company/widgets/employee-invite-list/employee-invite-list.tsx






const EmployeeInviteList = (props)=>{
    const onDelete = (0,react.useCallback)((data)=>{
        return use_modal/* Modals.open */.nK.open(EmployeeInviteDeleteModal, {
            companySlug: props.companySlug,
            data,
            onSuccess: ()=>{
                var _props_mutate;
                return (_props_mutate = props.mutate) === null || _props_mutate === void 0 ? void 0 : _props_mutate.call(props);
            }
        });
    }, [
        props.companySlug,
        props.mutate
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(list/* List */.a, {
        ...props,
        empty: /*#__PURE__*/ (0,jsx_runtime.jsx)(empty/* Empty */.H, {
            title: "Нет приглашений"
        }),
        renderItem: (it)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(EmployeeInviteEntity, {
                data: it,
                menuItems: /*#__PURE__*/ (0,jsx_runtime.jsx)(menu_item/* MenuItem */.s, {
                    type: "error",
                    onClick: ()=>onDelete(it),
                    children: "Удалить приглашение"
                })
            })
    });
};
EmployeeInviteList.defaultProps = {};

// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/shared/ui/tabs/tabs.tsx
var tabs = __webpack_require__(75173);
// EXTERNAL MODULE: ./src/pages/[company]/settings/_layout.tsx
var _layout = __webpack_require__(10830);
;// CONCATENATED MODULE: ./src/pages/[company]/settings/users.page.tsx







const CompanyUsersPage = ()=>{
    var _employeeList_data, _employeeInviteList_data;
    const { query  } = (0,router.useRouter)();
    const companySlug = query.company;
    const [selected, setSelected] = (0,react.useState)("employees");
    const employeeList = init/* api.companyEmployee.useCompanyEmployeeList */.h.companyEmployee.useCompanyEmployeeList(companySlug);
    const employeeInviteList = init/* api.companyEmployeeInvite.useCompanyEmployeeInviteList */.h.companyEmployeeInvite.useCompanyEmployeeInviteList(companySlug);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(_layout/* CompanySettingsLayout */.Q, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(EmployeeInviteCreateForm, {
                companySlug: companySlug
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(tabs/* Tabs */.m, {
                        tabs: [
                            {
                                value: "employees",
                                title: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        "Сотрудники ",
                                        employeeList.data && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                            children: [
                                                "(",
                                                (_employeeList_data = employeeList.data) === null || _employeeList_data === void 0 ? void 0 : _employeeList_data.length,
                                                ")"
                                            ]
                                        })
                                    ]
                                })
                            },
                            {
                                value: "invites",
                                title: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        "Отправленные приглашения ",
                                        employeeInviteList.data && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                            children: [
                                                "(",
                                                (_employeeInviteList_data = employeeInviteList.data) === null || _employeeInviteList_data === void 0 ? void 0 : _employeeInviteList_data.length,
                                                ")"
                                            ]
                                        })
                                    ]
                                })
                            }
                        ],
                        selected: selected,
                        setSelected: setSelected
                    }),
                    selected === "employees" && /*#__PURE__*/ (0,jsx_runtime.jsx)(EmployeeList, {
                        companySlug: companySlug,
                        ...employeeList
                    }),
                    selected === "invites" && /*#__PURE__*/ (0,jsx_runtime.jsx)(EmployeeInviteList, {
                        companySlug: companySlug,
                        ...employeeInviteList
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var users_page = (CompanyUsersPage);


/***/ }),

/***/ 72064:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ Label; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _label_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(53056);
/* harmony import */ var _label_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_label_module_scss__WEBPACK_IMPORTED_MODULE_3__);




const Label = (props)=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_label_module_scss__WEBPACK_IMPORTED_MODULE_3___default().label), props.className),
        style: props.style,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: (_label_module_scss__WEBPACK_IMPORTED_MODULE_3___default().label_title),
                children: props.value
            }),
            props.children
        ]
    });
};
Label.defaultProps = {};


/***/ }),

/***/ 75173:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ Tabs; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _tabs_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(23839);
/* harmony import */ var _tabs_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_tabs_module_scss__WEBPACK_IMPORTED_MODULE_3__);





const Tabs = (props)=>{
    const onSelectTab = (value)=>{
        props.setSelected(value);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_tabs_module_scss__WEBPACK_IMPORTED_MODULE_3___default().tabs), props.className),
        style: props.style,
        id: props.htmlId,
        children: props.tabs.map((elem, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                onClick: ()=>onSelectTab(elem.value),
                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_tabs_module_scss__WEBPACK_IMPORTED_MODULE_3___default().item), elem.value === props.selected && (_tabs_module_scss__WEBPACK_IMPORTED_MODULE_3___default().active)),
                children: [
                    elem.icon,
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        children: elem.title
                    })
                ]
            }, index))
    });
};


/***/ }),

/***/ 60978:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"company_expired":"company-expired_company_expired__1K5vq","inner":"company-expired_inner__2NWWa"};

/***/ }),

/***/ 87834:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"add_employee_form":"employee-invite-create-form_add_employee_form__01VtS","email":"employee-invite-create-form_email__S_m_Z","select":"employee-invite-create-form_select__opBDg","add_employees":"employee-invite-create-form_add_employees__tp0nF"};

/***/ }),

/***/ 10078:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sidebar":"sidebar_sidebar__sYHpc","sticky":"sidebar_sticky__tqhuP","sidebar_adaptive":"sidebar_sidebar_adaptive__It1u0","adaptive_item":"sidebar_adaptive_item__UCFjh","title":"sidebar_title__41UVT","item":"sidebar_item__3MhXw","active":"sidebar_active__ezSut","group_title":"sidebar_group_title__gZU9o","spacer":"sidebar_spacer__WlMwR"};

/***/ }),

/***/ 11682:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"with_sidebar_container":"with-sidebar-container_with_sidebar_container__nlbUn","sidebar":"with-sidebar-container_sidebar__s3m9i","main":"with-sidebar-container_main__UyQ8Z","hide_on_mobile":"with-sidebar-container_hide_on_mobile__F4a_D"};

/***/ }),

/***/ 53056:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"label":"label_label__NtXHf","label_title":"label_label_title__8WtV_"};

/***/ }),

/***/ 13412:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"snippet":"snippet_snippet__aSknK","button":"snippet_button__ULtXP","text":"snippet_text__x4rDy","success_fill":"snippet_success_fill__Z73q8","error_fill":"snippet_error_fill__RUp_e","warning_fill":"snippet_warning_fill__OGud_","secondary_fill":"snippet_secondary_fill__G9rys","lite_fill":"snippet_lite_fill__dUFln","success":"snippet_success__aBUke","error":"snippet_error__Oz9Xd","warning":"snippet_warning__mwbUc","secondary":"snippet_secondary__S5Gco","lite":"snippet_lite__HefSN"};

/***/ }),

/***/ 23839:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"tabs":"tabs_tabs__ZGwNe","item":"tabs_item__t1gkU","active":"tabs_active__GJA9B","itemBeforeShow":"tabs_itemBeforeShow__jEIDz"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7165,5675,1664,6657,4321,4894,5555,9774,2888,179], function() { return __webpack_exec__(63395); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);